import type { ExperimentalQueries } from '../__types__/ExperimentalQueries';

export const experimentalDesPromotionEligibility: ExperimentalQueries['experimentalDesPromotionEligibility'] =
	async (_, { cloudId, domain }, { network }) => {
		if (!cloudId) {
			return Promise.reject(new Error('cloudId is missing.'));
		}

		if (!domain) {
			return Promise.reject(new Error('domain is missing.'));
		}

		const queryString = new URLSearchParams({
			resource: `ari:cloud:confluence::site/${cloudId}`,
			domain,
			setting: 'DIRECT_ACCESS',
		}).toString();

		return network
			.cfetch(
				`/gateway/api/invitations/v1/settings/domain-enabled-signup-promotion?${queryString}`,
				{
					method: 'GET',
				},
			)
			.then((res) => res.json());
	};
